<div class="contacts-container mt-4">
  <div class="d-grid contacts-header">
    <div class="d-flex align-items-center contact-title-wrapper">
      <img
        src="assets/svg/money-icon.svg"
        width="20"
        class="contact-section-icon"
      />
      <h3 class="text-semibold contact-title">Partidas de presupuestos (2)</h3>
    </div>
    <div class="d-flex justify-self-end gap-10">
      <button class="action-btn primary" (click)="openAddProductModal()">
        Agregar productos
      </button>
      <button class="action-btn btn-primary-outline" (click)="openAddPItemModal()">
        Crear partida
      </button>
    </div>
  </div>

  <div class="prospectos-table mt-3">
    <table class="stage-history-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <span>Producto</span>
              <img src="assets/svg/arrow-down-black.svg" class="sort-icon" />
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Precio de venta</span>
              <img src="assets/svg/arrow-down-black.svg" class="sort-icon" />
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Cantidad</span>
              <img src="assets/svg/arrow-down-black.svg" class="sort-icon" />
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Subtotal</span>
              <img src="assets/svg/arrow-down-black.svg" class="sort-icon" />
            </div>
          </th>
          <th>
            <div class="th-content">
              <span></span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items">
          <td>{{ item.producto_servicio }}</td>
          <td>{{ item.precio_unitario | currency:'CLP':'symbol':'1.0-0' }}</td>
          <td>{{ item.cantidad }}</td>
          <td>
            {{ (item.cantidad * item.precio_unitario) |
            currency:'CLP':'symbol':'1.0-0' }}
          </td>
        </tr>

        <tr *ngIf="!items.length">
          <td colspan="4" class="text-center">No hay productos agregados.</td>
        </tr>

        <tr class="view-all-row">
          <td colspan="6" class="text-center">
            <button
              class="verTodos-footer btn btn-link color-org"
              style="
                width: 125px;
                height: 32px;
                border-radius: 32px;
                border: 1px solid;
                background-color: white;
              "
              (click)="navigateToFullTable($event)"
              value="detail"
            >
              Ver todos
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="contacts-container mt-4">
  <div class="d-grid contacts-header">
    <div class="d-flex align-items-center contact-title-wrapper">
      <img
        src="assets/svg/money-icon.svg"
        width="20"
        class="contact-section-icon"
      />
      <h3 class="text-semibold contact-title">
        Archivos PDF de presupuestos ({{ versiones.length }})
      </h3>
    </div>
  </div>

  <div class="prospectos-table mt-3" *ngIf="versiones.length; else noPdfVersions">
    <table class="stage-history-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <span>Nombre</span>
              <img src="assets/svg/arrow-down-black.svg" class="sort-icon" />
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Descuento</span>
              <img src="assets/svg/arrow-down-black.svg" class="sort-icon" />
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Total</span>
              <img src="assets/svg/arrow-down-black.svg" class="sort-icon" />
            </div>
          </th>
          <th>
            <div class="th-content">
              <span>Creado por</span>
              <img src="assets/svg/arrow-down-black.svg" class="sort-icon" />
            </div>
          </th>
          <th>
            <div class="th-content">
              <span></span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let v of versiones | slice:0:10">
          <td>
            <div
              class="d-flex flex-row align-items-center color-org"
              style="cursor: pointer;"
              (click)="downloadVersionPDF(v)"
            >
              <u>{{ buildVersionFileName(v) }}</u>
            </div>
          </td>

          <td>
            {{ v.totales?.descuento_global ?? 0 }}%
          </td>

          <td>
            {{
              (v.totales?.total || v.totales?.precio_total || 0)
                | currency:'CLP':'symbol':'1.0-0'
            }}
          </td>

          <td>
            <div class="d-flex flex-row align-items-center">
              {{ v.modificado_por?.nombre }} {{ v.modificado_por?.apellido }}
            </div>
          </td>

          <td>...</td>
        </tr>

        <tr class="view-all-row">
          <td colspan="5" class="text-center">
            <button
              class="btn btn-link color-org"
              style="
                width: 125px;
                height: 32px;
                border-radius: 32px;
                border: 1px solid;
                background-color: white;
              "
              (click)="navigateToFullTable($event)"
              value="pdf"
            >
              Ver todos
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #noPdfVersions>
    <p class="mt-3">No hay versiones de presupuesto guardadas aún.</p>
  </ng-template>
</div>

<div class="contacts-container mt-4">
  <div class="d-grid contacts-header">
    <div class="d-flex align-items-center contact-title-wrapper">
      <img
        src="assets/svg/folder-icon.svg"
        width="20"
        class="contact-section-icon"
      />
      <h3 class="text-semibold contact-title">Archivos ({{uploadedFiles.length}})</h3>
    </div>
    <div class="justify-self-end">
      <label for="file-upload" class="action-btn primary d-flex align-items-center cursor-pointer mb-0">
        <img src="assets/svg/upload-arrow-icon.svg" width="20" class="me-2" />
        Subir archivos
      </label>
      <input 
        id="file-upload" 
        type="file" 
        multiple 
        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif" 
        (change)="onFileSelected($event)"
        style="display: none;"
      >
    </div>
  </div>
  <div class="contacts-body mt-3" style="max-height: 25vh; overflow-y: auto;" *ngIf="uploadedFiles.length > 0">
    <div class="uploaded-files mt-3">
      <div *ngFor="let file of uploadedFiles" class="file-item d-flex align-items-center mb-2">
        <img src="assets/svg/folder-icon.svg" width="16" class="me-2">
        <a [href]="file.url" target="_blank" class="file-link">{{ file.nombre }}</a>
       <button class="btn-delete" (click)="onDeleteFile(file)">
        <img src="assets/svg/close-icon.svg" width="16">
       </button>
      </div>
    </div>
  </div>
</div>

<div class="contacts-container mt-4">
  <div class="d-grid contacts-header">
    <div class="d-flex align-items-center contact-title-wrapper">
      <img
        src="assets/svg/notes-icon.svg"
        width="20"
        class="contact-section-icon"
      />
      <h3 class="text-semibold contact-title">Notas (0)</h3>
    </div>
    <div class="justify-self-end">
      <button class="action-btn primary">Agregar nota</button>
    </div>
  </div>
</div>
